import InputComponent from './Input';
import Label from './Label';
import TextArea from './TextArea';
import Password from './Password';
import MultiSelectInput from './MultiSelectInput';
import AutoComplete from './AutoComplete';
const Input = InputComponent;
Input.Label = Label;
Input.TextArea = TextArea;
Input.Password = Password;
Input.MultiSelectInput = MultiSelectInput;
Input.AutoComplete = AutoComplete;
export default Input;
